module.exports = __webpack_public_path__ + "static/media/etsy-green-lamp.3e1d08c0.png";